export enum CapacityFilterOperatorEnum {
    MoreOrEqual = ">=",
    More = ">",
    Equal = "=",
    LessOrEqual = "<=",
    Less = "<"
}